module.exports = __webpack_public_path__ + "static/media/yash_core.24bc2625.jpeg";